"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const constants_1 = require("../../lib/constants");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const star_rating_1 = __importDefault(require("./star-rating"));
const AverageRating = ({ averageRating, ratingCount, reviewCount, intl }) => {
    return (react_1.default.createElement(styles_1.AverageRatingContainer, null,
        react_1.default.createElement(star_rating_1.default, { rating: averageRating, starSize: constants_1.RATINGS_AND_REVIEWS.SUMMARY_STAR_SIZE_DESKTOP, widthAccuracyCorrection: constants_1.RATINGS_AND_REVIEWS.SUMMARY_STARS_ACCURACY_CORRECTION_WIDTH }),
        react_1.default.createElement("meta", { itemProp: "worstRating", content: "1" }),
        react_1.default.createElement("meta", { itemProp: "bestRating", content: "5" }),
        react_1.default.createElement(styles_1.AverageRatingHeading, { itemProp: "ratingValue", content: averageRating.toString(), tabIndex: 0, "aria-label": `${intl.formatMessage(messages_1.default.ariaStarRatingsAverage, {
                averageRating,
                rating: averageRating
            })}` }, `${averageRating} ${intl.formatMessage(messages_1.default.ratingScale)}`),
        react_1.default.createElement(styles_1.RatingsReviewsCount, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.ratingReviewCount, { values: {
                    ratingCount,
                    reviewCount,
                    ratings: ratingCount,
                    reviews: reviewCount
                } })),
            react_1.default.createElement("span", { className: "sr-only", "aria-hidden": true },
                react_1.default.createElement("span", { itemProp: "ratingCount" }, ratingCount),
                react_1.default.createElement("span", { itemProp: "reviewCount" }, reviewCount)))));
};
exports.default = (0, intl_1.injectIntl)(AverageRating);
//# sourceMappingURL=average-rating.js.map